import { render, staticRenderFns } from "./step-finished.vue?vue&type=template&id=715c900d&scoped=true"
import script from "./step-finished.vue?vue&type=script&lang=js"
export * from "./step-finished.vue?vue&type=script&lang=js"
import style0 from "./step-finished.vue?vue&type=style&index=0&id=715c900d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715c900d",
  null
  
)

export default component.exports